import { useEffect, useState } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import ScrollProgress from './components/base/ScrollProgress';
import FloatingActionButton from './components/base/FloatingActionButton';
import ChatbotWidget from './components/feature/ChatbotWidget';
import { AuthProvider } from './context/AuthContext';
import { pushDataLayerEvent } from './lib/analytics';
import { setStructuredData, siteOrganizationSchema } from './lib/seo';

function AppChrome() {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  useEffect(() => {
    setStructuredData('gec-site-schema', siteOrganizationSchema);
  }, []);

  useEffect(() => {
    const trackContactClick = (event: MouseEvent) => {
      const target = event.target instanceof Element ? event.target.closest<HTMLAnchorElement>('a[href]') : null;
      if (!target) return;
      const href = target.getAttribute('href') || '';
      if (/^(https?:\/\/)?(www\.)?(wa\.me|api\.whatsapp\.com)\//i.test(href)) {
        pushDataLayerEvent('whatsapp_click');
      } else if (href.toLowerCase().startsWith('tel:')) {
        pushDataLayerEvent('phone_click');
      }
    };
    document.addEventListener('click', trackContactClick);
    return () => document.removeEventListener('click', trackContactClick);
  }, []);

  const openWhatsApp = () => {
    const message = 'Hello! I would like to know more about your study abroad services.';
    pushDataLayerEvent('whatsapp_click');
    window.open(`https://wa.me/919020500700?text=${encodeURIComponent(message)}`, '_blank');
  };

  return <div className="min-h-screen bg-white">
    {!isAdmin && <ScrollProgress />}
    <AppRoutes />
    {!isAdmin && <>
      <FloatingActionButton onClick={openWhatsApp} position="bottom-left" className="w-14 h-14 bg-green-500 hover:bg-green-600" icon="ri-whatsapp-fill" title="Chat on WhatsApp" delay={0.5} />
      <FloatingActionButton onClick={() => setIsChatbotOpen(true)} position="bottom-right" className="px-6 py-4 bg-gradient-to-r from-purple-600 to-pink-600" icon="ri-robot-line" title="Chat with AI Agent" delay={1}>
        <span className="hidden sm:inline">Chat With AI Agent</span>
        <span className="sm:hidden">AI Chat</span>
      </FloatingActionButton>
      <ChatbotWidget isOpen={isChatbotOpen} onClose={() => setIsChatbotOpen(false)} />
    </>}
  </div>;
}

function App() {
  return <BrowserRouter basename={__BASE_PATH__}>
    <AuthProvider><AppChrome /></AuthProvider>
  </BrowserRouter>;
}

export default App;
